'use strict';

const upSellCaroussel = function () {

    const _initUpsellCarrousel = function () {
        let isPlpGridList = $('.plpGridList');
        if (!isPlpGridList.length) {
            productTileSlick();
        }
        $('.select-addToCart').on('change', selectProductOptionPriceUpdate);
        showProductsPreviousErrors();

        $('.close-upSell-panel').on('click', function () {
            $('.product-upSell-container').addClass('closing');
            closeUpSellPanel();
        });
    }

    return {
        initUpsellCarrousel: _initUpsellCarrousel
    }
}();

$(document).ready(function () {
    upSellCaroussel.initUpsellCarrousel();

});